export interface Iempresa {
    ID: number;
    Name: string;
    Direccion: string;
    RUC: string;
    RazonSocial: string;
    Agent: string;
    Dni: string;
    status: boolean;
    UserCreation: string;
    DateCreation: string;
    UserLastUpdate: string;
    DateLastUpdate: string;
    StatusName: string;
    imagenFirma: string;
    nombreCorto: string;
}


export class Empresa implements Iempresa {
    constructor(
        public ID: number,
        public Name: string,
        public Direccion: string,
        public RUC: string,
        public RazonSocial: string,
        public Agent: string,
        public Dni: string,
        public status: boolean,
        public UserCreation: string,
        public DateCreation: string,
        public UserLastUpdate: string,
        public DateLastUpdate: string,
        public StatusName: string,
        public imagenFirma: string,
        public nombreCorto: string,
    ) {
        this.ID = ID;
        this.Name = Name;
        this.Direccion = Direccion;
        this.RUC = RUC;
        this.RazonSocial = RazonSocial;
        this.Agent = Agent;
        this.Dni = Dni
        this.status = status;
        this.UserCreation = UserCreation;
        this.DateCreation = DateCreation;
        this.UserLastUpdate = UserLastUpdate;
        this.DateLastUpdate = DateLastUpdate;
        this.StatusName = StatusName;
        this.imagenFirma = imagenFirma;
        this.nombreCorto = nombreCorto;
    }

}

